import { useCallback } from "react";

import { useStartGoogleAuth } from "../api/hooks/useDriveSync";

const GOOGLE_CALLBACK_PATH = "/google/callback";

// Read by GoogleAuthCallbackRoute to send the operator back where they started.
export const GOOGLE_RETURN_TO_KEY = "inrange.google_return_to";

export const googleCallbackUri = (): string =>
  `${window.location.origin}${GOOGLE_CALLBACK_PATH}`;

// Starts Google's OAuth consent flow. A failure surfaces through the shared
// mutation error toast.
export const useConnectGoogle = (
  loginHint: string | undefined,
  // Set on the global-data page only, where connecting makes this account the one
  // that writes agent documents into Drive. Everywhere else the consent screen
  // stays read-only, so nobody is asked to agree to creating files their account
  // will never create.
  options?: { forAgentDocuments?: boolean },
) => {
  const startAuth = useStartGoogleAuth();
  const forAgentDocuments = options?.forAgentDocuments ?? false;
  const connect = useCallback(() => {
    sessionStorage.setItem(
      GOOGLE_RETURN_TO_KEY,
      window.location.pathname + window.location.search,
    );
    startAuth.mutate(
      {
        redirect_uri: googleCallbackUri(),
        login_hint: loginHint,
        for_agent_documents: forAgentDocuments,
      },
      {
        onSuccess: (resp) => {
          window.location.href = resp.auth_url;
        },
      },
    );
  }, [startAuth, loginHint, forAgentDocuments]);
  return { connect, connecting: startAuth.isLoading };
};
